import { connect } from 'react-redux';
import User from './User';
import { fetchUserById, update } from '../../../redux/actions/user';
import { createRoles, deleteRoles } from '../../../redux/actions/roles';
import { showToast } from '../../../redux/actions/toasts';
import { fetchRoles } from '../../../redux/actions/roles&permissions/roles';

const mapStateToProps = (state) => ({
  sso: state.institution.general.sso,
  roles: state.roles.roles,
});

const mapDispatchToProps = (dispatch) => ({
  fetchUser: (userId) => dispatch(fetchUserById(userId)),
  updateUser: (userId, data) => dispatch(update({ userId, data })),
  updateRole: (role) => dispatch(createRoles([role])),
  deleteRoles: (userId, _spaceId) => dispatch(deleteRoles(userId)),
  showToast: (payload) => dispatch(showToast(payload)),
  fetchRoles: () => dispatch(fetchRoles()),
});

export default connect(mapStateToProps, mapDispatchToProps)(User);
